/* eslint-disable no-param-reassign */
import { createReporter } from './reporter';
import { createDirective } from './directive';

let reporter;

export function useReporter() {
  return reporter;
}

function createGlobalApi(Vue, reporter) {
  Vue.prototype.$report = reporter;
  Vue.prototype.$reportExpose = (params) => {
    reporter.expose(params);
  };
  Vue.prototype.$reportClick = (params) => {
    reporter.click(params);
  };
  Vue.prototype.$reportModule = (params) => {
    reporter.report(params, 'module');
  };
  Vue.prototype.$reportReady = reporter.ready;
}

const plugin = {
  install(Vue, options) {
    const { middlewares = [], ...params } = options;
    reporter = createReporter(params, middlewares);
    createDirective(Vue, middlewares);
    createGlobalApi(Vue, reporter);
  },
};
export default plugin;
